import { createToastInterface } from "vue-toastification";

export default function (ctx, inject) {
  const toast = createToastInterface({"cssFile":"vue-toastification\u002Fdist\u002Findex.css","timeout":3000});
  inject('toast', toast);
}
